import {
	AnimatedFeedbackBlock,
	FeedbackAnimation,
} from "@bokio/components/AnimatedFeedbackBlock/AnimatedFeedbackBlock";
import { Button } from "@bokio/designsystem/components/Button";
import Icon from "@bokio/designsystem/components/Icon/Icon";
import { Modal } from "@bokio/designsystem/components/Modal";

import type { FontelloIcons } from "@bokio/assets/fontello";
import type { ReactNode } from "react";

import * as styles from "./successModal.scss";

interface SuccessModalProps {
	title: string;
	visible: boolean;
	collapsible?: boolean;
	alwaysMounted?: boolean;
	loading?: boolean;
	primaryButtonText?: string;
	primaryButtonIcon?: FontelloIcons;
	onPrimaryAction?: () => void;
	secondaryButtonText?: string;
	onSecondaryAction?: () => void;
	animation?: FeedbackAnimation;
	iconName?: FontelloIcons;
	children?: ReactNode;
	testId?: string;
	heading?: string;
	onClose: () => void;
}

export const SuccessModal = (props: SuccessModalProps) => {
	const {
		title,
		visible,
		collapsible,
		alwaysMounted = true,
		loading,
		primaryButtonText,
		primaryButtonIcon,
		onPrimaryAction,
		secondaryButtonText,
		onSecondaryAction,
		animation = FeedbackAnimation.Checkmark,
		children,
		testId,
		heading,
		onClose,
	} = props;

	return (
		<Modal
			title={heading}
			noHeader={!heading}
			testId={testId}
			visible={visible}
			onClose={onClose}
			alwaysMounted={alwaysMounted}
		>
			<div className={styles.wrapper}>
				{collapsible && !heading && (
					<Icon className={styles.closeIcon} name="cancel" size="24" onClick={onClose} testId="SuccessModal_Close" />
				)}
				<AnimatedFeedbackBlock
					title={title}
					animation={animation}
					buttons={[
						!!primaryButtonText ? (
							<Button
								key="primary"
								onClick={() => onPrimaryAction?.()}
								loading={loading}
								type="button"
								icon={primaryButtonIcon}
								testId="SuccessModal_PrimaryButton"
							>
								{primaryButtonText}
							</Button>
						) : undefined,
						!!secondaryButtonText ? (
							<Button
								key="secondary"
								onClick={() => onSecondaryAction?.()}
								type="button"
								appearance="secondary"
								testId="SuccessModal_SecondaryButton"
							>
								{secondaryButtonText}
							</Button>
						) : undefined,
					].filter(b => !!b)}
				>
					{children}
				</AnimatedFeedbackBlock>
			</div>
		</Modal>
	);
};
